import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  insert(event) {
    const placeholder = event.currentTarget.dataset.placeholder
    const textarea = this.textareaTarget
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const text = textarea.value

    textarea.value = text.substring(0, start) + placeholder + text.substring(end)
    textarea.selectionStart = textarea.selectionEnd = start + placeholder.length
    textarea.focus()

    textarea.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
